import { TeamSide } from '@collector/shared-domain'
import { Incident } from '@collector/sportsapi-types'
import { useBetIncidents } from '@desktop/views/Relation/Sports/composables'

export function useIncidentStyle(): {
  getIncidentTextClasses: (incident: Incident, isDeleted: boolean) => string
  getIncidentContainerClasses: (
    incident: Incident,
    teamSide: TeamSide | null,
    isDeleted: boolean,
  ) => string
} {
  // composables
  const { isEmergencyIncident, hasIncidentMasterAttribute, isBetIncident } =
    useBetIncidents()

  // methods
  function getIncidentTextClasses(
    incident: Incident,
    isDeleted: boolean,
  ): string {
    if (hasIncidentMasterAttribute(incident) || isEmergencyIncident(incident)) {
      return isDeleted ? 'text-error-2/50' : 'text-error-2'
    }

    if (isBetIncident(incident)) {
      return isDeleted ? 'text-error-3/50' : 'text-error-3'
    }

    return isDeleted ? 'text-neutral-dark-0/50' : 'text-neutral-dark-0'
  }

  function getIncidentContainerClasses(
    incident: Incident,
    teamSide: TeamSide | null,
    isDeleted: boolean,
  ): string {
    if (hasIncidentMasterAttribute(incident) || isEmergencyIncident(incident)) {
      return isDeleted
        ? 'bg-error-9/50 border-error-7/50'
        : 'bg-error-9 border-error-7'
    }

    if (isBetIncident(incident)) {
      return isDeleted
        ? 'bg-error-10/50 border-error-7/50'
        : 'bg-error-10 border-error-7'
    }

    if (teamSide === 'home') {
      return isDeleted
        ? 'bg-current-team-home-10/50 border-current-team-home-7/50'
        : 'bg-current-team-home-10 border-current-team-home-7'
    }

    if (teamSide === 'away') {
      return isDeleted
        ? 'bg-current-team-away-10/50 border-current-team-away-7/50'
        : 'bg-current-team-away-10 border-current-team-away-7'
    }

    return isDeleted
      ? 'bg-neutral-light-8/50 border-neutral-light-5/50'
      : 'bg-neutral-light-8 border-neutral-light-5'
  }

  return {
    getIncidentTextClasses,
    getIncidentContainerClasses,
  }
}
